import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import SectionLabel from "@/components/layout/SectionLabel";
import { ArrowRight } from "lucide-react";

const POSTS = [
  { cat: "Hot Water Savings", t: "How much does hot water cost in a New Zealand home?" },
  { cat: "Gas to Electric", t: "Heat pump hot water vs gas hot water: which is better?" },
  { cat: "Heat Pump Education", t: "Should I replace my electric cylinder with a heat pump?" },
  { cat: "Hot Water Savings", t: "270L vs 320L hot water heat pump: which size do I need?" },
  { cat: "Solar Ready Homes", t: "Can a hot water heat pump work with solar panels?" },
  { cat: "Heat Pump Education", t: "What photos do I need for a hot water quote?" },
  { cat: "Gas to Electric", t: "Gas disconnection in New Zealand: what homeowners should consider" },
  { cat: "NZ Home Electrification", t: "How to reduce household energy bills in New Zealand" },
  { cat: "Heat Pump Education", t: "What is R290 refrigerant in hot water heat pumps?" },
  { cat: "Heat Pump Education", t: "Is a heat pump hot water system suitable for my home?" },
];

export default function Blog() {
  return (
    <div className="bg-white">
      <section className="border-b border-[#E2E8F0]">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 py-20">
          <SectionLabel>Knowledge hub</SectionLabel>
          <h1 className="font-heading mt-4 text-4xl sm:text-6xl font-bold tracking-tight text-[#0B132B]">
            Insights for smarter Kiwi homes
          </h1>
          <p className="mt-5 text-lg text-[#475569] max-w-2xl">
            Practical, plain-English articles on hot water, heat pumps, gas-to-electric transitions, and NZ home electrification.
          </p>
        </div>
      </section>

      <section className="py-16 bg-[#F8FAFC]">
        <div className="max-w-6xl mx-auto px-6 sm:px-8 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {POSTS.map((p, i) => (
            <Card key={i} className="rounded-2xl p-6 border-[#E2E8F0] bg-white hover:shadow-md transition-all">
              <Badge variant="outline" className="rounded-full border-[#2563EB] text-[#2563EB] text-[10px]">{p.cat}</Badge>
              <p className="font-heading text-lg font-semibold text-[#0B132B] mt-4 leading-snug">{p.t}</p>
              <p className="text-xs text-[#475569] mt-3">Article coming soon — internal link to calculator & quote request.</p>
              <Link to="/savings-calculator" className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-[#2563EB]">
                Use the calculator <ArrowRight className="h-3.5 w-3.5" />
              </Link>
            </Card>
          ))}
        </div>
      </section>
    </div>
  );
}
